import { api } from './api';

// ─── Interfaces ────────────────────────────────────────────────────────────────

export interface User {
  id?: string;
  usuarioId?: number;
  email: string;
  nombre: string;
  rol?: {
    rolId: number;
    nombre: string;
  };
}

export interface LoginResponse {
  user: User;
  accessToken?: string; // Por si el backend retorna el token en el body en el futuro
}

// ─── Service ──────────────────────────────────────────────────────────────────

const ENDPOINT = '/auth';

export const authService = {
  login: (credentials: { email: string; password?: string }) =>
    api.post<LoginResponse>(`${ENDPOINT}/login`, credentials),

  logout: () =>
    api.post<{ message: string }>(`${ENDPOINT}/logout`),

  getMe: () =>
    api.get<{ user: User }>(`${ENDPOINT}/me`),
};
